import * as React from "react";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { Authorization } from "../../../misc/components/Authorization";
import { useFormApi, useFormState } from "informed";
import { FixedCommentSetFormModel, GetModelFromFormState, GetFormStateFromModel, InternalFormState, FixedCommentEntries } from "../types";
import { Link } from "react-router-dom";
import Condition from "../../../misc/components/Condition";
import { FixedCommentEntityTypeEnum } from "../../../misc/api/FixedComments/FixedCommentSetEntityTypes";
import { FixedCommentSetTypeEnum } from "../../../misc/api/FixedComments/FixedCommentSetTypes";
import { forEach } from "lodash";
import { SessionTypes } from "../../../misc/api/ApiSessionTypes";
import { Ats2019SessionDefaults, Ats2019TestDefaults } from "../Ats2019Defaults";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { EcgAlertDefaults, EcgInterpretationDefaults } from "../EcgInterpretationDefaults";
import { FixedComment } from "webportalclient";
import { useSecurityContext } from "../../../Core/SecurityContext";

interface CreateMenuItemsOwnProps {
    onSubmit: (values: FixedCommentSetFormModel) => void;
    onImportComments: (entries: FixedCommentEntries) => void;
}

export const FixedCommentsFormButtons = ({  onImportComments }: CreateMenuItemsOwnProps): JSX.Element => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    const formApi = useFormApi<FixedCommentSetFormModel>();

    const formState = useFormState<InternalFormState>();

    const submitForm = () => {
        formApi.submitForm();
    };

    const populateComments = async (defaultComments: FixedComment[]) => {
        const values = GetModelFromFormState(formApi.getState().values, study.id);

        const allComments = defaultComments.map(c => {
            const existingComment = values.fixedCommentSets[0].comments.find(v => v.id == c.id);

            return existingComment || c;
        });

        forEach(values.fixedCommentSets[0].comments, c => {
            const existingComment = allComments.find(v => v.id == c.id);

            if (!existingComment) {
                allComments.push(c);
            }
        });

        onImportComments(GetFormStateFromModel({
            ...values,
            fixedCommentSets: [{
                comments: allComments
            }]
        }).Comments);
    }

    const populateATS2019Comments = async () => {
        const ats2019Defaults = formState.values.EntityType === FixedCommentEntityTypeEnum.Session ? Ats2019SessionDefaults : Ats2019TestDefaults;

        populateComments(ats2019Defaults);
    };

    const populateEcgAlerts = async () => {
        populateComments(EcgAlertDefaults);
    }

    const populateEcgInterpretations = async () => {
        populateComments(EcgInterpretationDefaults);
    }

    return (<div className="ibox-tools">
        <Condition test={() => formState.values.SetType === FixedCommentSetTypeEnum.Technician && formState.values.SessionType === SessionTypes.Fvc && (formState.values.EntityType === FixedCommentEntityTypeEnum.Session || formState.values.EntityType === FixedCommentEntityTypeEnum.Test)}>
            <button onClick={(e) => {
                e.preventDefault();
                populateATS2019Comments();
            }} className="btn btn-primary right">Import ATS 2019 Comments</button>
        </Condition>
        <Condition test={() => formState.values.SetType === FixedCommentSetTypeEnum.Overread && formState.values.SessionType === SessionTypes.Ecg && (formState.values.EntityType === FixedCommentEntityTypeEnum.Alerts)}>
            <button onClick={(e) => {
                e.preventDefault();
                populateEcgAlerts();
            }} className="btn btn-primary right">Import Default ECG Alerts</button>
        </Condition>
        <Condition test={() => formState.values.SetType === FixedCommentSetTypeEnum.Overread && formState.values.SessionType === SessionTypes.Ecg && (formState.values.EntityType === FixedCommentEntityTypeEnum.Test)}>
            <button onClick={(e) => {
                e.preventDefault();
                populateEcgInterpretations();
            }} className="btn btn-primary right">Import Default ECG Interpretations</button>
        </Condition>
        <Authorization permissionId={PermissionEnum.CreateFixedComment}
            studyId={study.id}
            currentPermissions={currentUserPermissions}
        >
            <button id="saveForm" onClick={(e) => {
                e.preventDefault();
                submitForm();
            }} className="btn btn-primary">Save</button>
        </Authorization>
        <Link id="cancelForm" to="/FixedComments" className="btn btn-primary btn-outline">Cancel</Link>
    </div>);
};
